export const SymbolLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="80"
      // height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        d="M63.5 45L58.5 40L63.5 35L68.5 40L63.5 45Z"
        stroke="#E54D2E"
        strokeWidth="16"
        strokeLinecap="square"
      />
      <path
        d="M8 23H42"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path d="M8 64L23 24H27L42 64" stroke="#E54D2E" strokeWidth="15" />
    </svg>
  );
};
